import { render, staticRenderFns } from "./AppProductSearchBar.vue?vue&type=template&id=13d46d41&scoped=true"
import script from "./AppProductSearchBar.vue?vue&type=script&lang=js"
export * from "./AppProductSearchBar.vue?vue&type=script&lang=js"
import style0 from "./AppProductSearchBar.vue?vue&type=style&index=0&id=13d46d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d46d41",
  null
  
)

export default component.exports